import type {
  UserRegion,
  UserRole,
  UserSearchParams,
  UserSourceValue,
  UserStatus,
} from "@/services/users";

export type RoleFilter = "All" | UserRole;
export type StatusFilter = "All" | UserStatus;
export type RegionFilter = "All" | UserRegion;
export type SourceFilter = "All" | UserSourceValue;

export interface UserFilterState {
  page: number;
  pageSize: number;
  keyword: string;
  role: RoleFilter;
  status: StatusFilter;
  region: RegionFilter;
  generalSourceTypeId: string;
  source?: SourceFilter;
}

export function buildUserSearchParams(filters: UserFilterState): UserSearchParams {
  const params: UserSearchParams = {
    Page: filters.page,
    Limit: filters.pageSize,
  };

  const keyword = filters.keyword.trim();
  if (keyword) params.Keyword = keyword;
  if (filters.role !== "All") params.Role = filters.role;
  if (filters.status !== "All") params.Status = filters.status;
  if (filters.region !== "All") params.Region = filters.region;
  if (filters.source && filters.source !== "All") params.Source = filters.source;
  if (filters.generalSourceTypeId !== "All") {
    params.GeneralSourceTypeId = filters.generalSourceTypeId;
  }

  return params;
}
